const IPIFY_URL = 'https://api.ipify.org?format=json';

let cachedIpAddress: string | null = null;
let inflightLookup: Promise<string | undefined> | null = null;

function readNonEmptyTrimmedString(value: unknown): string | undefined {
  if (typeof value !== 'string' || value.trim().length === 0) {
    return undefined;
  }

  return value.trim();
}

async function fetchIpFromIpify(): Promise<string | undefined> {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    const response = await fetch(IPIFY_URL);
    if (!response.ok) {
      return undefined;
    }

    const data = (await response.json()) as { ip?: string };
    return readNonEmptyTrimmedString(data.ip);
  } catch {
    return undefined;
  }
}

/**
 * Resolves the browser's public IP via ipify. Result is cached for the page session
 * and concurrent callers share one in-flight request.
 */
export async function getClientIpAddress(): Promise<string | undefined> {
  if (cachedIpAddress !== null) {
    return cachedIpAddress;
  }

  if (inflightLookup) {
    return inflightLookup;
  }

  inflightLookup = fetchIpFromIpify().then(ip => {
    if (ip !== undefined) {
      cachedIpAddress = ip;
    }

    return ip;
  });

  try {
    return await inflightLookup;
  } finally {
    inflightLookup = null;
  }
}

/** Clears cached IP (for tests). */
export function resetClientIpAddressCache(): void {
  cachedIpAddress = null;
  inflightLookup = null;
}
